import * as React from 'react';

import { ReportTypes } from '@showbie-socrative/socrative-utils';
import { translate } from '~l10n/client';

import { CommonProps, ExportReportPanel } from './ExportReportPanel';
import { MCAnswerContent, ReportOptionType } from './ReportOption';

const ExportReportsCompleteResults = (props: CommonProps) => {
  const reportOptions: ReportOptionType[] = [MCAnswerContent];
  return (
    <ExportReportPanel
      {...props}
      shouldShowProBadgeInHeader={false}
      shouldShowProBadge={true}
      shouldShowPaywallOnReportsButtonClicked={false}
      description={translate(
        'Export an Excel file of responses and scores for all students who took part in the activity.'
      )}
      title={translate('Complete Results Excel')}
      reportOptions={reportOptions}
      initialOptions={props.initialOptions}
      reportRequestSelectedType={ReportTypes.WholeClassExcel}
    />
  );
};

export { ExportReportsCompleteResults };
export default ExportReportsCompleteResults;
